<template>
  <span>
    <!-- <div v-if="browserSize.sm == true || browserSize.xs == true">
      <v-parallax
        id="massage"
        :src="require('../assets/massageSmall.jpg')"
        height="200"
      >
      </v-parallax>
    </div>
    <div v-else>
      <v-parallax :src="require('../assets/massage3.jpg')" height="400">
      </v-parallax>
    </div> -->
    <v-img
      src="../assets/massage3.jpg"
      alt="fizjoterapia"
      height="50vh"
    ></v-img>
  </span>
</template>

<script>
export default {
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.offers {
  margin-top: 12vh;
}
.listMargin {
  margin: 5px;
}
.imageDiv {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.color {
  text-shadow: 2px 2px #3e2723;
  color: #f5f5f5;
}
.infText {
  margin: auto;
}
.v-application .grey--text {
  color: #414149 !important;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.name {
  margin: 10px;
  color: #414149 !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
  margin-left: 4vw;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.textCenter {
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
}
h1 {
  margin: auto;
}
</style>
